import { navItems, titleForPath } from "./navigation";

export const routeAnnouncement = (pathname: string) => `${titleForPath(pathname)} loaded`;
export const routeTransitionTitle = (pathname: string) => titleForPath(pathname);
export const ROUTE_TRANSITION_MODE = "sync" as const;
export const routeOwnsViewport = (pathname: string): boolean =>
  pathname === "/games" || pathname.startsWith("/games/") || pathname === "/chat" || pathname === "/board";
const ROUTE_TRANSITION_DURATION_S = 1.2;
const navPath = (pathname: string) =>
  pathname.startsWith("/games")
    ? "/games"
    : pathname === "/chat" || pathname.startsWith("/chats")
      ? "/chats"
      : navItems.find(({ path }) => pathname === path || pathname.startsWith(`${path}/`))?.path;
export const routeTransitionDirection = (from: string, to: string): 1 | -1 => {
  const fromIndex = navItems.findIndex(({ path }) => path === navPath(from));
  const toIndex = navItems.findIndex(({ path }) => path === navPath(to));
  return fromIndex >= 0 && toIndex >= 0 && toIndex < fromIndex ? -1 : 1;
};
export const routeTransitionMotion = (reducedMotion: boolean, direction: 1 | -1) =>
  reducedMotion
    ? { initial: { y: 0 }, animate: { y: 0 }, exit: { y: 0 } }
    : {
        initial: { y: `${direction * 112}dvh` },
        animate: {
          y: [`${direction * 112}dvh`, `${direction * 112}dvh`, 0],
          transition: { duration: ROUTE_TRANSITION_DURATION_S, times: [0, 0.65, 1], ease: [0.76, 0, 0.24, 1] as const },
        },
        exit: {
          y: [0, `${direction * -112}dvh`, `${direction * -112}dvh`],
          transition: { duration: ROUTE_TRANSITION_DURATION_S, times: [0, 0.35, 1], ease: [0.76, 0, 0.24, 1] as const },
        },
      };
